import { useApi } from '../instance';
import { NonogramPuzzle, NonogramSubmitAnswerBody, NonogramTopTime, NonogramTopTimes } from './types';

export const useNonogramPuzzleById = (id: number) => {
  return useApi<NonogramPuzzle, { id: number }>(
    {
      url: `nonograms/by-id/${id}`,
    },
  );
};

export const useNonogramPuzzleBySize = (size: number) => {
  return useApi<NonogramPuzzle, { size: number }>(
    {
      url: `nonograms/by-size/${size}`,
    },
  );
};

export const useNonogramPuzzleDaily = (date?: string) => {
  return useApi<NonogramPuzzle, { date?: string }>(
    {
      url: `nonograms/daily${date ? `/${date}` : ''}`,
    },
  );
};

export const useNonogramTopTimes = () => {
  return useApi<NonogramTopTimes[]>(
    {
      url: 'nonograms/top-times',
    },
  );
};

export const useNonogramDailyTopTimes = (date?: string) => {
  return useApi<NonogramTopTime[]>(
    {
      url: `nonograms/top-times/daily${date ? `/${date}` : ''}`,
    },
  );
};

export const useNonogramDailyTopTimesByMonth = (year: number, month: number) => {
  return useApi<
    Record<number, { date: string; size: number; fastestTime: number | null }>
  >(
    {
      url: `nonograms/top-times/daily/by-month/${year}-${
        month.toString().padStart(2, '0')
      }`,
    },
  );
};

export const useNonogramSubmitAnswer = () => {
  return useApi<{ success: boolean }, NonogramSubmitAnswerBody>(
    {
      url: 'nonograms/submit-solution',
      method: 'POST',
    },
    { manual: true },
  );
};